import Stronghold from "src/core/payments/stronghold/Stronghold";
import OfflinePayment from "src/core/payments/offline/OfflinePayment";
import Spence from "src/core/payments/spence/Spence";
import Merrco from "src/core/payments/merrco/Merrco";
import Moneris from "src/core/payments/moneris/Moneris";

export const PaymentOptions = {
  STRONGHOLD: "stronghold",
  SPENCE: "spence",
  MERRCO: "merrco",
  MONERIS: "moneris",
};

export function makePayment(type) {
  switch (type) {
    case PaymentOptions.STRONGHOLD:
      return new Stronghold(type);
    case PaymentOptions.SPENCE:
      return new Spence(type);
    case PaymentOptions.MERRCO:
      return new Merrco(type);
    case PaymentOptions.MONERIS:
      return new Moneris(type);
    default:
      return new OfflinePayment(type);
  }
}
